import CoreUtils from '../utils/CoreUtils';
import DateTimeUtils from '../utils/DateTimeUtils';

export default class DefaultValue {
  static resolveValue(metadataRule) {
    if (CoreUtils.isUndefinedOrNull(metadataRule))
      return null;

    switch (metadataRule.type) {
      case 'boolean':
        return DefaultValue.resolveBooleanValue(metadataRule);
      case 'cutoff':
        return DefaultValue.resolveCutOffValue(metadataRule);
      case 'datetime':
        return DefaultValue.resolveDateTimeValue(metadataRule);
      case 'guid':
        return DefaultValue.resolveGuidValue(metadataRule);
      case 'number':
        return DefaultValue.resolveNumberValue(metadataRule);
      case 'sata-config':
        return DefaultValue.resolveSataConfigurationValue(metadataRule);
      case 'quick-entry-config':
        return DefaultValue.resolveQuickEntryConfigurationValue(metadataRule);
      case 'select':
        return DefaultValue.resolveSelectValue(metadataRule);
      case 'string':
        return DefaultValue.resolveStringValue(metadataRule);
      case 'string-list':
        return DefaultValue.resolveStringListValue(metadataRule);
      case 'timespan':
        return DefaultValue.resolveTimeSpanValue(metadataRule);
      default:
        return null;
    }
  }

  static resolveBooleanValue(metadataRule) {
    return metadataRule.defaultValue;
  }

  static resolveCutOffValue(metadataRule) {
    return metadataRule.defaultValue;
  }

  static resolveDateTimeValue(metadataRule) {
    switch (metadataRule.defaultValue) {
      case 'Empty':
        return null;
      case 'Now':
        return DateTimeUtils.toDtoDateTime(DateTimeUtils.getNow());
      case 'Today':
        return DateTimeUtils.toDtoDateTime(DateTimeUtils.getToday());
      case 'ThisMonth':
        return DateTimeUtils.toDtoDateTime(
          metadataRule.restrictionType === 'DateOnlyEndOfMonth'
            ? DateTimeUtils.nudgeDateToLastDayOfMonth(DateTimeUtils.getThisMonth())
            : DateTimeUtils.getThisMonth()
        );
      case 'NextMonth':
        return DateTimeUtils.toDtoDateTime(
          metadataRule.restrictionType === 'DateOnlyEndOfMonth'
            ? DateTimeUtils.nudgeDateToLastDayOfMonth(DateTimeUtils.getNextMonth())
            : DateTimeUtils.getNextMonth()
        );
      default:
        return null;
    }
  }

  static resolveGuidValue(metadataRule) {
    return metadataRule.defaultValue === 'GenerateNew'
      ? crypto.randomUUID()
      : null;
  }

  static resolveNumberValue(metadataRule) {
    return metadataRule.defaultValue;
  }

  static resolveSataConfigurationValue(metadataRule) {
    return metadataRule.defaultValue;
  }

  static resolveQuickEntryConfigurationValue(metadataRule) {
    return metadataRule.defaultValue;
  }

  static resolveSelectValue(metadataRule) {
    return metadataRule.options.find(option => option.value === metadataRule.defaultValue)
  }

  static resolveStringValue(metadataRule) {
    return metadataRule.defaultValue;
  }

  static resolveStringListValue(metadataRule) {
    return metadataRule.defaultValue;
  }

  static resolveTimeSpanValue(metadataRule) {
    return metadataRule.defaultValue;
  }
}